import filterChromakey from "../filters/chromakey";

export default [
  { label: "クロマキー透過 (左上から)", value: filterChromakey },
];
